import { render, staticRenderFns } from "./CotizacionNotificacion.vue?vue&type=template&id=63c205de&scoped=true"
import script from "./CotizacionNotificacion.vue?vue&type=script&lang=js"
export * from "./CotizacionNotificacion.vue?vue&type=script&lang=js"
import style0 from "./CotizacionNotificacion.vue?vue&type=style&index=0&id=63c205de&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c205de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63c205de')) {
      api.createRecord('63c205de', component.options)
    } else {
      api.reload('63c205de', component.options)
    }
    module.hot.accept("./CotizacionNotificacion.vue?vue&type=template&id=63c205de&scoped=true", function () {
      api.rerender('63c205de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/notificaciones/editInfo/CotizacionNotificacion.vue"
export default component.exports